export const reportsConstants = {
    GET_REPORTS_REQUEST: 'GET_REPORTS_REQUEST',
    GET_REPORTS_SUCCESS: 'GET_REPORTS_SUCCESS',
    GET_REPORTS_FAILURE: 'GET_REPORTS_FAILURE',

    GET_DATA_REPORTS_REQUEST: 'GET_DATA_REPORTS_REQUEST',
    GET_DATA_REPORTS_SUCCESS: 'GET_DATA_REPORTS_SUCCESS',
    GET_DATA_REPORTS_FAILURE: 'GET_DATA_REPORTS_FAILURE',
    GET_DATA_REPORTS_RESET: 'GET_DATA_REPORTS_RESET',
  }